export default class AudioPlayer extends HTMLElement {
  constructor() {
    super();
    this.currentlyPlaying = false;
    this.productPlaylist = document.querySelector('product-playlist[data-type="product"]');
    if (this.productPlaylist) {
      this.setPlaylist(this.productPlaylist.getTracklist());
    }
    this.elements = {
      cover: this.querySelector('#cover'),
      track: this.querySelector('#track'),
      playBtn: this.querySelector('#playBtn'),
      pauseBtn: this.querySelector('#pauseBtn'),
      prevBtn: this.querySelector('#prevBtn'),
      nextBtn: this.querySelector('#nextBtn'),
      progress: this.querySelector('#progress'),
      wave: this.querySelector('#waveform'),
      playlist: this.querySelector('#playlist'),
      list: document.querySelector('ol.product__tracklist-list'),
      audioPlayer: this.querySelector('#audioPlayer'),
      title: this.querySelector('#product-title'),
      closeBtn: this.querySelector('#close'),
    }
    this.init();
    

    this.elements.playBtn.addEventListener('click', this.onPlay.bind(this));
    this.elements.pauseBtn.addEventListener('click', this.onPause.bind(this));
    this.elements.closeBtn.addEventListener('click', this.onClose.bind(this));
    this.elements.prevBtn.addEventListener('click', this.onPrev.bind(this));
    this.elements.nextBtn.addEventListener('click', this.onNext.bind(this));
    this.elements.wave.addEventListener('click', this.onWave.bind(this));
  }

  setPlaylist(playlist) {
    if (playlist !== this.playlist) {
      // this.elements.allControlButtons.forEach(buttons => {
      //   buttons.querySelector('.single-play').classList.remove('hidden');
      //   buttons.querySelector('.single-pause').classList.add('hidden');
      // });
    }
    this.playlist = playlist;
  }

  init(currentPlayer) {
    if (currentPlayer) {
      this.currentlyPlayingImage = currentPlayer.querySelector('.media');
      this.currentlyPlayingLink = currentPlayer.querySelector('a').href;
      this.currentlyPlayingTitle = currentPlayer.querySelector('a').textContent;
      var clonedImage = this.currentlyPlayingImage.cloneNode(true);
      this.elements.cover.innerHTML = '<a href="' + this.currentlyPlayingLink + '"></a>';
      this.elements.title.innerHTML = this.currentlyPlayingTitle;

      this.elements.cover.querySelector('a').appendChild(clonedImage);
    }

    if (this.currentlyPlaying) {
      if (currentPlayer !== this.currentlyPlaying) {
        console.log('hier pauzeknoppen aan');
        this.currentlyPlaying.querySelector('.single-play').classList.remove('hidden');
        this.currentlyPlaying.querySelector('.single-pause').classList.add('hidden');

      }
    }
    this.currentlyPlaying = currentPlayer;

    if (!this.playlist) return;
    if (howler) {
      // console.log(howler.Howler.playing());
      
      howler.Howler.stop();
      if (this.list) { 
        this.list.querySelector('.single-play').classList.remove('hidden');
        this.list.querySelector('.single-pause').classList.add('hidden');
      }
    }
    var self = this;
      var Player = function(playlist, howler) {
      this.playlist = self.playlist;
      this.howler = howler;
        this.index = 0;
      
    // Display the title of the first track.
  
  
  };
  Player.prototype = {
  
    /**
     * Play a song in the playlist.
     * @param  {Number} index Index of the song in the playlist (leave empty to play the first or current).
     */
    play: function (index) {
       var sound;
       audioPlayer.classList.remove('hidden');
      this.file = audioPlayer.dataset.file;
      this.list = audioPlayer.elements.list;
      if (!this.list) {
        if (!audioPlayer.collectionPlaylist) return;
        this.list = audioPlayer.collectionPlaylist;
      }

      this.productElement = this.list.closest('collection-card-list');
      if (this.productElement) {
      this.currentlyPlayingTitle = this.productElement.querySelector('.card-information__text').textContent;
      this.currentlyPlayingLink = this.productElement.querySelector('.card-information__text').href;
      this.currentlyPlayingImage = this.productElement.querySelector('.media');
        var clonedImage = this.currentlyPlayingImage.cloneNode(true);
        audioPlayer.elements.cover.innerHTML = '<a href="' + this.currentlyPlayingLink + '"></a>';
        audioPlayer.elements.title.innerHTML = this.currentlyPlayingTitle;

        audioPlayer.elements.cover.querySelector('a').appendChild(clonedImage);
      }
      
      var self = this;
      
      index = typeof index === 'number' ? index : self.index;
      var data = self.playlist[index];

  
      // If we already loaded this track, use the current one.
      // Otherwise, setup and load a new Howl.
      if (data.howl) {
        sound = data.howl;
      } else {
        sound = data.howl = new Howl({
          src: [data.file],
          html5: true, // Force to HTML5 so that the audio can stream in (best for large files).
          onplay: function (id, e) {

  
            // Start updating the progress of the track.
            requestAnimationFrame(self.step.bind(self));
            if (self.list) {
              self.list.querySelectorAll('.list-song').forEach(song => {
                song.classList.remove('paused')
              });
            }
            
            pauseBtn.style.display = 'block';
          },
          onload: function() {
          },
          onend: function() {
            self.skip('next');
          },
          onpause: function () {
            if (self.list) {

              self.list.querySelector('.list-song.playing').classList.add('paused');
              self.list.querySelector('.list-song.playing').classList.remove('playing');
            }
          },
          onstop: function () {
            // self.list.querySelector('.single-play').classList.remove('hidden');
            // self.list.querySelector('.single-pause').classList.add('hidden');
          },
          onseek: function() {
            // Start updating the progress of the track.
            requestAnimationFrame(self.step.bind(self));
          }
        });
      }

  
      // Begin playing the sound.

      sound.play();
      // Update the track display.
      track.innerHTML = (index + 1) + '/' + self.playlist.length + '. ' + data.title.split('.mp3')[0];
      if (self.list) {
        self.list.querySelectorAll('.list-song').forEach(song => {
          if (song) {
            song.classList.remove('playing')
          }
        });
        if (!self.list.querySelector('.list-song[data-track-number="' + index + '"]')) return;
        self.list.querySelector('.list-song[data-track-number="' + index + '"]').classList.add('playing');
      }

  
      
  
      // Show the pause button.
      if (sound.state() === 'loaded') {
        if (self.list.querySelector('.single-play')) {
          self.list.querySelector('.single-play').classList.add('hidden');
        }
        if (self.list.querySelector('.single-pause')) {
          self.list.querySelector('.single-pause').classList.remove('hidden');
        }

        playBtn.style.display = 'none';
        pauseBtn.style.display = 'block';
      } else {
        if (self.list.querySelector('.single-play')) {
          self.list.querySelector('.single-play').classList.add('hidden');
        }
        if (self.list.querySelector('.single-pause')) {
          self.list.querySelector('.single-pause').classList.remove('hidden');
        }
        playBtn.style.display = 'none';
        pauseBtn.style.display = 'none';
      }
  
      // Keep track of the index we are currently playing.
      self.index = index;
    },
  
    /**
     * Pause the currently playing track.
     */
    pause: function() {
      var self = this;
  
      // Get the Howl we want to manipulate.
        var sound = self.playlist[self.index].howl;
  
      // Puase the sound.
      sound.pause();
  
      // Show the play button.
      playBtn.style.display = 'block';
      pauseBtn.style.display = 'none';
      if (self.list) {
        
      
        if (self.list.querySelector('.single-play')) {
          self.list.querySelector('.single-play').classList.remove('hidden');
        };
        if (self.list.querySelector('.single-pause')) {
          self.list.querySelector('.single-pause').classList.add('hidden');
        }
      }
    },
  
    /**
     * Skip to the next or previous track.
     * @param  {String} direction 'next' or 'prev'.
     */
    skip: function(direction) {
      var self = this;
  
      // Get the next track based on the direction of the track.
      var index = 0;
      if (direction === 'prev') {
        index = self.index - 1;
        if (index < 0) {
          index = self.playlist.length - 1;
        }
      } else {
        index = self.index + 1;
        if (index >= self.playlist.length) {
          index = 0;
        }
      }
  
      self.skipTo(index);
    },
  
    /**
     * Skip to a specific track based on its playlist index.
     * @param  {Number} index Index in the playlist.
     */
    skipTo: function (index) {
      var self = this;
  
      // Stop the current track.
      if (self.playlist[self.index].howl) {
        self.playlist[self.index].howl.stop();
      }
  
      // Reset progress.
      progress.style.width = '0%';
  
      // Play the new track.
      self.play(index);
    },
  
    /**
     * Seek to a new position in the currently playing track.
     * @param  {Number} per Percentage through the song to skip.
     */
    seek: function(per) {
      var self = this;
  
      // Get the Howl we want to manipulate.
      var sound = self.playlist[self.index].howl;
  
      // Convert the percent into a seek position.
      sound.seek(sound.duration() * per);
      if (!sound.playing()) {
        self.play();
      }
    },
  
    /**
     * The step called within requestAnimationFrame to update the playback position.
     */
    step: function() {
      var self = this;
  
      // Get the Howl we want to manipulate.
      var sound = self.playlist[self.index].howl;
  
      // Determine our current seek position.
      var seek = sound.seek() || 0;
      progress.style.width = (((seek / sound.duration()) * 100) || 0) + '%';
  
      // If the sound is still playing, continue stepping.
      if (sound.playing()) {
        requestAnimationFrame(self.step.bind(self));
      }
    },
  
    /**
     * Format the time from seconds to M:SS.
     * @param  {Number} secs Seconds to format.
     * @return {String}      Formatted time.
     */
    formatTime: function(secs) {
      var minutes = Math.floor(secs / 60) || 0;
      var seconds = (secs - minutes * 60) || 0;
  
      return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
    }
  };
    this.player = new Player(this.tracklist);
  }

  onPlay(event) {

    event.preventDefault();
    this.player.play();
  }

  onPause(event) {
    event.preventDefault();
    this.player.pause();
  }

  onPrev(event) {
    event.preventDefault();
    this.player.skip('prev');

  }

  onNext(event) {
    event.preventDefault();
    this.player.skip('next');
  }

  onWave(event) {
    event.preventDefault();
    this.player.seek(event.offsetX / this.elements.wave.offsetWidth);
  }

  onClose(event) {
    event.preventDefault();
    this.classList.add('hidden');

    this.player.pause();
  }


}